import { c as _c } from "react/compiler-runtime";
import { ArrowRight, ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
interface HeroSectionProperties {
  isLoading: boolean;
  onLogin: () => void;
}
export function HeroSection(t0) {
  const $ = _c(11);
  const {
    onLogin,
    isLoading
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Badge className="mb-4 border border-primary/40 bg-primary/15 text-primary-foreground">Built for signal-first operators</Badge>;
    t2 = <h1 className="text-5xl md:text-6xl font-bold mb-6 text-foreground">Every feature you need to own your timeline</h1>;
    t3 = <p className="text-xl text-muted-foreground max-w-3xl mx-auto mb-8">Advanced AI-powered insights, real-time monitoring, and network optimization tools built to help you understand and grow your own Twitter presence—without waiting on anyone else.</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = isLoading ? "Connecting..." : "Get Started Free";
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowRight className="ml-2 h-4 w-4" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isLoading || $[5] !== onLogin || $[6] !== t4) {
    t6 = <Button onClick={onLogin} className="bg-primary text-primary-foreground hover:bg-primary/90" disabled={isLoading}>{t4}{t5}</Button>;
    $[4] = isLoading;
    $[5] = onLogin;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button variant="outline" asChild={true}><Link href="/pricing">View Pricing<ChevronRight className="ml-2 h-4 w-4" /></Link></Button>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <section className="relative px-4 py-20 bg-gradient-to-br from-background via-muted/20 to-background"><div className="max-w-6xl mx-auto text-center">{t1}{t2}{t3}<div className="flex gap-4 justify-center">{t6}{t7}</div></div></section>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}